export default __webpack_public_path__ + "static/media/NOKO_4.49c5b28f.gif";